import React from 'react'
import { PanelBarGLPure, ButtonAddHLPure, GridSelectionHLPure, DialogExtractEntities } from '../../pures'


const ButtonExtractEntities = ({ submitExtract, t, disabled }) => {
  return (
    <ButtonAddHLPure
      nameBtn={t('documentPanelBarEntities.btns.extract.entities')}
      onClickBtn={submitExtract}
      iconAdd={true}
      disabled={disabled}
    />
  )
}

const HeaderColumns = ({ t, title }) => {
  const isFirstHeader = (
    title === t('documentPanelBarEntities.grid.title.1') ||
    title === t('documentPanelBarEntities.grid.title.row.1')
  )
  const isActionsHeader = title === t('documentPanelBarEntities.grid.title.2')
  const baseClass = isFirstHeader ? 'grid-header-one entities-header-first' : 'grid-headers'
  const className = `${baseClass}${isActionsHeader ? ' entities-actions-header' : ''}`
  return <span className={className}>{title}</span>
}

const CellColumnName = ({ dataItem, t }) => {
  return (
    <td>
      <div className='grid-cell-double-container-margin-left entities-cell-offset'>
        <p className='grid-cell-titles-margin-left'>{dataItem?.name}</p>
        <p className='grid-cell-subtitles'>{dataItem?.type}</p>
      </div>
    </td>
  )
}

const CellColumnActions = ({ dataItem, onUseEntity, t }) => {
  return (
    <td>
      <div className={'cellActions-containerBtnsDetails'}>
        <button
          className='cellActions-btn'
          title={t('documentPanelBarEntities.grid.action.btn.tooltip')}
          onClick={() => onUseEntity && onUseEntity(dataItem)}
        >
          <p className='cellActions-textBotton'>{t('documentPanelBarEntities.grid.action.btn')}</p>
        </button>
      </div>
    </td>
  )
}

/**
 * @author Edgar Escobedo
 * @description Panel bar that displays document entities.
 * @createdDate 03-09-2025
 * @typedef {Object} Props
 * @property {function} t - Function to translate text.
 * @property {[{type:String, name:String}]} entities - List of document entities.
 * @property {String} entitiesStatus - Status of entities document.
 * @property {boolean} showDialogExtractEntities - Flag to show/hide the extract entities dialog.
 * @property {function} setShowDialogEntities - Function to open the extract entities dialog.
 * @property {function} setCloseDialogEntities - Function to close the extract entities dialog.
 * @property {function} saveExtractedEntities - Function to save the extracted entities.
 * @property {Array} documentsToOCR - List of documents to be sent to OCR.
 * @property {number} totalCredits - Total credits to be spent when sending documents to OCR
 * @property {function} handleCheckBoxDoc - Function to select or deselect documents.
 * @property {(entity:any)=>void} [onUseEntity] - Optional: callback when clicking "Convertir a dato".
 * @param {Props} props
 * @returns {JSX.Element}
 */
const DocumentPanelBarEntities = ({ t, entities, entitiesStatus, showDialogExtractEntities, setShowDialogEntities, setCloseDialogEntities, saveExtractedEntities, documentsToOCR, totalCredits, handleCheckBoxDoc, onUseEntity, isInDeleteFlow }) => {
  const ENV = process.env
  const panelActionButton = (!entitiesStatus) ? <ButtonExtractEntities t={t} submitExtract={() => setShowDialogEntities()} disabled={isInDeleteFlow} /> : null
  let messageNoEntities = t('documentPanelBarEntities.message.no.entities')

  if (entitiesStatus === ENV.REACT_APP_EVENT_TRANSACTION_STATUS_OCR_PENDING ||
    entitiesStatus === ENV.REACT_APP_EVENT_TRANSACTION_STATUS_OCR_PROCESSING) {
    messageNoEntities = t('documentPanelBarEntities.message.processing')
  }

  const allHeadersColumns = (props) => <HeaderColumns {...props} t={t} />

  // Columns grid entities
  const cellColumnOne = (props) => <CellColumnName {...props} t={t} />
  const cellColumnTwo = (props) => <CellColumnActions {...props} onUseEntity={onUseEntity} t={t} />

  // Columns grid document entities

  // Keep internal min widths in px; CSS enforces final 60/40 split
  let widthCellOne = '150px'
  let widthCellTwo = '90px'
  // Fixed height: keep consistent panel height regardless of records
  const heightGrid = 'var(--panelHeight)'
  const total = Array.isArray(entities) ? entities.length : 0

  return (
    <div className='documentPanelBarEntities-wrapper'>
      <PanelBarGLPure
        expandedPanel={true}
        titlePanel={t('documentPanelBarEntities.panel.title')}
        className='documentPanelBarVariables'
        id='documentPanelBarVariables'
        actionComponent={panelActionButton}
      >

        <div className='documentPanelBarEntities-grid'>
          <GridSelectionHLPure
            styleGeneral={true}
            styleGeneralClass={'documentPanelBarEntities-general-grid'}
            pageable={false}
            skip={0}
            take={total}
            dataGrid={entities}
            noRecordsMessage={messageNoEntities}

            columnOne={true}
            columnTwo={true}
            columnThree={false}

            titleRow1={t('documentPanelBarEntities.grid.title.row.1')}
            titleRow2={t('documentPanelBarEntities.grid.title.2')}
            titleRow3={''}

            cellColumnOne={cellColumnOne}
            cellColumnTwo={(isInDeleteFlow) ? null : cellColumnTwo}
            cellColumnThree={null}

            headerColumnOne={allHeadersColumns}
            headerColumnTwo={allHeadersColumns}
            headerColumnThree={null}

            widthColumnOne={widthCellOne}
            widthColumnTwo={widthCellTwo}
            widthColumnThree={null}

            minResizableWidth1={widthCellOne}
            minResizableWidth2={'auto'}
            minResizableWidth3={null}
            styleGrid={{ height: heightGrid }}
          />
        </div>
      </PanelBarGLPure>
      {
        showDialogExtractEntities && (
          <DialogExtractEntities
            documentsToOCR={documentsToOCR}
            totalCredits={totalCredits}
            onClickCheckBox={handleCheckBoxDoc}
            closeModalEntities={setCloseDialogEntities}
            saveEntities={saveExtractedEntities}
            onClickSkipBtn={setCloseDialogEntities}
          />
        )
      }
    </div>
  )
}

export default DocumentPanelBarEntities